function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import GmapCustomMarker from "vue2-gmap-custom-marker";
export default {
  components: {
    "gmap-cluster": GmapCluster,
    "gmap-custom-marker": GmapCustomMarker
  },
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      infoWindowOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoWindowOpen: false,
      infoWindowPosition: null,
      selectedMarker: null,
      center: {
        lat: 0,
        lng: 0
      },
      zoom: 11,
      markers: []
    };
  },
  methods: {
    // See https://stackoverflow.com/questions/37597324/markercluster-one-marker-for-a-group for calculator example
    _calculator: function _calculator(markers, numStyles) {
      var sum = 0;

      var _iterator = _createForOfIteratorHelper(markers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var marker = _step.value;
          sum += Number(marker.title);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        text: sum,
        index: 0,
        title: ""
      };
    },
    // attachScript: function(elementId, url) {
    //   if (document.getElementById(elementId) == null) {
    //     const script = document.createElement('script')
    //     script.setAttribute('id', elementId)
    //     script.setAttribute('src', url)
    //     script.setAttribute('defer', 'defer')
    //     document.body.appendChild(script)
    //   }
    // },
    // renderGoogleMap: function() {
    //   const mapView = this.$refs.map
    //   const spec = this.spec
    //   window.googleMaps = window.googleMaps || {
    //     initializers: [],
    //     init: function() {
    //       for (const exec of this.initializers) {
    //         exec()
    //       }
    //     }
    //   }
    //   window.googleMaps.initializers.push(
    //     function() {
    //       const map = new google.maps.Map(mapView, {zoom: spec.zoom || 10})
    //       map.setCenter({lat: spec.latitude, lng: spec.longitude})
    //       //var marker = new google.maps.Marker({position: center, map: map})
    //     }
    //   )
    //   this.attachScript('__google_map_script', `https://maps.googleapis.com/maps/api/js?key=${process.env.GMAPS_API_KEY}&callback=googleMaps.init`)
    // },
    // renderBaiduMap: function() {
    //   const mapView = this.$refs.map
    //   const spec = this.spec
    //   window.baiduMaps = window.baiduMaps || {
    //     initializers: [],
    //     init: function() {
    //       for (const exec of this.initializers) {
    //         exec()
    //       }
    //     }
    //   }
    //   window.baiduMaps.initializers.push(
    //     function() {
    //       // NOTE: Outside of China, coordinate conversion is still not accurate. See Macomatic's answer on
    //       // https://stackoverflow.com/questions/29444803/does-a-google-maps-coordinate-map-to-the-same-location-in-baidu-maps
    //       // This is why the BMap.Convertor solution doesn't point to the right location during our testing.
    //       var map = new BMap.Map(mapView);
    //       map.centerAndZoom(new BMap.Point(123.404, 39.815), spec.zoom || 10)
    //       map.enableScrollWheelZoom()
    //     }
    //   )
    //   this.attachScript('__baidu_map_script', "http://api.map.baidu.com/api?v=1.5&ak=2b866a6daac9014292432d81fe9b47e3&callback=baiduMaps.init")
    // },
    $ready: function $ready() {
      var _this = this;

      var _this$spec = this.spec,
          latitude = _this$spec.latitude,
          longitude = _this$spec.longitude,
          zoom = _this$spec.zoom;

      if (this.$type.isNumber(latitude) && this.$type.isNumber(longitude)) {
        this.updateMapCenter(latitude, longitude);
      }

      this.$type.ifNumber(zoom, function (val) {
        return _this.zoom = val;
      });
      this.fetchMarkers();
    },
    updateMapCenter: function updateMapCenter(lat, lng) {
      this.center.lat = lat;
      this.center.lng = lng;
    },
    fetchMarkers: function fetchMarkers() {
      var _this2 = this;

      var _this$center = this.center,
          lat = _this$center.lat,
          lng = _this$center.lng;
      var url = new URL(this.spec.dataUrl);
      url.searchParams.append("lat", lat);
      url.searchParams.append("long", lng);
      Utils.http.execute({
        url: url.toString()
      }, "GET", this, function (response) {
        _this2.markers = response.pins;
      });
    },
    onInfoWindowClose: function onInfoWindowClose() {
      this.infoWindowOpen = false;
      this.infoWindowPosition = null;
      this.selectedMarker = null;
    },
    onMarkerClick: function onMarkerClick(marker, index) {
      this.selectedMarker = marker;
      this.infoWindowPosition = {
        lat: marker.latitude,
        lng: marker.longitude
      };
      this.infoWindowOpen = true;
    },
    onMapDragEnd: function onMapDragEnd(e) {
      var center = this.$refs.map.$mapObject.center;
      this.updateMapCenter(center.lat(), center.lng());
      this.fetchMarkers();
    }
  } // mounted: function() {
  //   // switch (this.spec.provider) {
  //   // case 'baidu':
  //   //   this.renderBaiduMap()
  //   //   break
  //   // default:
  //   //   this.renderGoogleMap()
  //   // }
  //   const { latitude, longitude, zoom } = this.spec
  //   this.updateMapCenter(latitude, longitude)
  //   this.zoom = zoom
  //   this.fetchMarkers()
  // }

};